<mat-toolbar class="groupName">
    <h2 class="title">Site Level Configuration</h2>
    <button class="close-button" mat-dialog-close aria-label="close-icon">X</button>
</mat-toolbar>
<div mat-dialog-content class="content-container">
    <div class="left-section">
        <div class="p-10">
            <input type="text" placeholder="Search..." (input)="handleInput($event)" class="search">
        </div>
        <table class="light-border-table">
            <thead>
                <th class="column">Potential ID</th>
                <th class="column">Site Name</th>
                <th class="column">Site Unit ID</th>
                <th class="column col-width">Skip India TSS for Outage Ticket Resolution for ITAR Sites</th>
                <th class="column">Outage Ticket Threshold (Hrs)</th>
            </thead>
            <tbody *ngIf="filteredParentAccounts?.length; else noDataTemplate">
              <tr *ngFor="let data of filteredParentAccounts" [class.selected]="selectedAccounts.includes(data)" class="toggle">
                <td>{{data?.potentialId}}</td>
                <td>{{data?.siteName}}</td>
                <td>{{data?.unitId}}</td>
                <td>
                  <select (change)="toggleAccountSelection(data, $event, 'status')">
                    <option [selected]="data?.status == false" [value]="false">No</option>
                    <option [selected]="data?.status == true" [value]="true">Yes</option>
                  </select>
                </td>
                <td>
                  <select (click)="$event.stopPropagation()" (change)="toggleAccountSelection(data, $event, 'duration')">
                    <option [selected]="data?.ticketCreationDuration" [value]="data?.ticketCreationDuration ?? 5" hidden>
                      {{ data?.ticketCreationDuration ?? 5}}
                    </option>
                    <option *ngFor="let option of filteredDropdownOptions(filteredParentAccounts)" [value]="option">
                      {{ option }}
                    </option>
                  </select>
                </td>
              </tr>
            </tbody>
        </table>
        <ng-template #noDataTemplate>
            <tr>
                <td colspan="5" class="noData">
                    <div class="loading-container">{{ isLoading ? 'Loading...' : 'NO DATA FOUND' }}</div>
                </td>
            </tr>
        </ng-template>
    </div>

    <div class="popup-dialog" *ngIf="showDialog">
        <div class="popup-content">
          <h1 class="popup-title">Confirmation Request</h1>
          <h1 class="popup-title">Skip India TSS for Outage Ticket Resolution for ITAR Sites has been Adjusted</h1>
          <div class="action-buttons">
            <button mat-button mat-raised-button color="primary" class="submit-btn" (click)="submitData()">SUBMIT</button>
            <button mat-button mat-raised-button color="warn" class="close-btn" (click)="closeDialog()">CLOSE</button>
          </div>
        </div>
    </div>

    <div class="popup-dialog" *ngIf="showConfirmDialog">
        <div class="popup-content">
          <h1 class="popup-title">Confirm Selected Changes</h1>
          <h2 class="popup-title">The Outage Threshold has been Adjusted</h2>
          <div class="action-buttons">
            <button mat-button mat-raised-button color="primary" class="submit-btn" [disabled]="!canSubmit()" (click)="submitData()">SUBMIT</button>
            <button mat-button mat-raised-button color="warn" class="close-btn" (click)="closeDialog()">CLOSE</button>
          </div>
        </div>
    </div>

    <div class="popup-dialog" *ngIf="showBothChangedDialog">
      <div class="popup-content">
        <h1 class="popup-title">Confirm Changes</h1>
        <h2 class="popup-title">Both Outage Threshold and Skip India TSS have been Adjusted</h2>
        <div class="action-buttons">
          <button mat-button mat-raised-button color="primary" class="submit-btn" 
                  (click)="submitData()">SUBMIT</button>
          <button mat-button mat-raised-button color="warn" class="close-btn" 
                  (click)="closeDialog()">CLOSE</button>
        </div>
      </div>
    </div>
      
</div>
<div mat-dialog-actions class="actions">
    <button mat-button mat-raised-button color="primary" class="submit" [disabled]="!canSubmit()" (click)="openDialog()">SELECT</button>
    <button mat-button mat-raised-button color="primary" class="history" (click)="getHistory()">HISTORY</button>
</div>